import { Injectable } from '@angular/core';

import {httpOptions} from '../../configurations/configuration';
import { HttpClient, HttpHeaders,HttpErrorResponse} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AssetGroupService {
    constructor(private http: HttpClient) { }

    updateAssetGroup(postObj:any) : Observable<any> {

        postObj.langId = localStorage.getItem('languageId');
        if(postObj.langId== null){
            postObj.langId = '1';
        }
        console.log('postobj',postObj);

        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.updateAssetGroupUrl, postObj,httpOptions);
    }

    insertAssetGroup(postObj:any) : Observable<any> {

        postObj.langId = localStorage.getItem('languageId');

        if(postObj.langId== null){
            postObj.langId = '1';
        }

        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.insertAssetGroupUrl, postObj,httpOptions);
    }

    getAssetGroup( id: any, langId:any) : Observable<any> {

        langId = localStorage.getItem('languageId');

        if(langId == null){
            langId = '1';
        }

        if(id){
            return this.http.get(environment.apiURL + environment.adminApiUrl + environment.getAssetGroupUrl+"/" + id +"/" + langId);
        }

    }

    getAllAssetGroup(filterObj,start,limit){

        filterObj.languageId = localStorage.getItem('languageId');
        if(filterObj.languageId == null){
            filterObj.languageId = '1';
        }


        let urlGetAllAssetGroup = environment.apiURL + environment.adminApiUrl + environment.getAssetGroupUrl +'?filter='+encodeURIComponent(JSON.stringify(filterObj))+'&start='+start+'&limit='+limit;
        return this.http.get<any>(urlGetAllAssetGroup)
    }

    deleteAssetGroup(postObj:any) : Observable<any> {
        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.deleteAssetGroupUrl, postObj,httpOptions);
    }
    deleteGroupMultiple(postObj:any) : Observable<any> {
      return this.http.post(environment.apiURL + environment.adminApiUrl + environment.deleteMultipleAssetgroup, postObj,httpOptions);
  }
}
